import { Button, ButtonLink, ButtonSizes, ButtonStyles, EntityChip, Icon, TextInput } from '@silverfort/sf-components';
import { useState } from 'react';

const ChipBank = ({
    validateListItem,
    removeAllData,
    removeData,
    data,
    listTitle,
    icon,
    shouldShowAddPannel = true,
    validateInput,
    addData,
    placeholder = '',
    inputClassName = '',
    listClassName = '',
    clearButtonClassName = '',
    clearButtonText = 'Remove all'
}) => {
    const [inputString, setInputString] = useState('');
    const [validationMessage, setValidationMessage] = useState();

    const handleInput = () => {
        const inputArray = inputString.split(',').map((str) => str.trim());
        if (inputArray.length > 1) {
            setInputString('');
            addData(inputArray);
        } else if (inputArray.length === 1) {
            const validation = validateInput(inputArray[0]);
            if (validation) {
                setValidationMessage(validation);
            } else {
                setInputString('');
                addData(inputArray);
            }
        }
    };

    return (
        <div>
            {shouldShowAddPannel && (
                <div className={`flex gap-2 ${inputClassName}`}>
                    <div className="flex flex-1 flex-col">
                        <TextInput
                            validationMessage={validationMessage}
                            placeholder={placeholder}
                            value={inputString}
                            onChange={(val) => {
                                setValidationMessage();
                                setInputString(val);
                            }}
                            className="w-full"
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    handleInput();
                                }
                            }}
                        />
                    </div>
                    <Button
                        text={'Add'}
                        onClick={handleInput}
                        buttonSize={ButtonSizes.Large}
                        buttonStyle={ButtonStyles.Primary}
                        textSize="text-12"
                    />
                </div>
            )}
            <div className={`${listClassName} border rounded-lg flex flex-col mt-4`}>
                <div className="flex text-12 items-center justify-between border-b px-3 py-2">
                    <span className="flex items-center text-sf-gray-500 text-12 gap-1">
                        {icon && <Icon icon={icon} className="h-4 w-4" />}
                        {listTitle ? `${listTitle} (${data.length})` : data.length}
                    </span>
                    <ButtonLink
                        text={clearButtonText}
                        onClick={removeAllData}
                        underline
                        className={clearButtonClassName}
                    />
                </div>
                <div className="flex flex-wrap items-start content-start gap-[8px] px-[10px] py-[8px] h-full overflow-y-auto">
                    {data.map((datum, i) => (
                        <EntityChip
                            key={i}
                            text={datum}
                            removable
                            onRemove={() => removeData(datum, i)}
                            invalid={validateListItem(datum)}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ChipBank;
